module.exports = __webpack_public_path__ + "static/media/BTS_FINALS-6.8027e9ec.jpg";